import React from 'react';
import { sanitizeUrl } from '@braintree/sanitize-url';

function Image(props) {
  const { src, name, className, style } = props;
  return <img src={sanitizeUrl(src)} className={className} style={style} alt={name} title={name} />;
}

export default Image;



// WEBPACK FOOTER //
// ./src/js/widgets/Image.js